import { Logger } from '../common/logger';
import { statusDefaultData, handleStatusData } from './helpers/status-model';
import { JOB_VERSION_CHECK_DELAY, JOB_VERSION_CHECK_INTERVAL, JOB_SYSTEM_STATUS_CHECK_JOB } from '../common/constants';
import axiosInstance from '../utils/axiosInstance';

export const systemStatus = {
    name: 'systemStatus',
    state: {
        systems: [...statusDefaultData],
        version: {
            status: 'Loading…',
            lastReceived: null,
        },
    },
    reducers: {
        resetSystemStatus(state) {
            return { ...state, systems: [...statusDefaultData] };
        },
        systemsStatusLoad(state, payload) {
            if (payload) {
                Logger.debug('System status loaded', payload);
                return { ...state, systems: handleStatusData([...state.systems], payload) };
            }
            Logger.warn('Systems status is undefined');
            return state;
        },
        loadVersion(state, payload) {
            return { ...state, version: payload };
        },
    },
    effects: (dispatch) => ({
        async initializeSystemStatus() {
            Logger.log('System status setup');
            dispatch.systemStatus.resetSystemStatus();
            dispatch.systemStatus.versionJob();
        },

        async reset() {
            Logger.info('Reset SystemStatus');
            dispatch.systemStatus.resetSystemStatus();
        },

        async checkJob() {
            try {
                while (true) {
                    await new Promise((resolve) => setTimeout(resolve, JOB_SYSTEM_STATUS_CHECK_JOB));
                    Logger.log('Checking system status.');
                    dispatch.systemStatus.systemsStatusLoad();
                }
            } catch (err) {
                Logger.error('Error starting checkJob', err);
            }
        },

        async versionJob() {
            const delayMs = JOB_VERSION_CHECK_INTERVAL;
            await new Promise((resolve) => setTimeout(resolve, JOB_VERSION_CHECK_DELAY));

            while (true) {
                try {
                    Logger.log('Checking version.');
                    const { data } = await axiosInstance.get('/version.json');
                    let status = 'No information';

                    const hasData = window.BUILD_ID && data && data.githash;
                    if (hasData) {
                        status = window.BUILD_ID === data.githash ? 'Up to date' : 'Outdated';
                    }

                    dispatch.systemStatus.loadVersion({
                        ts: data.timestamp,
                        ver: data.version,
                        githash: data.githash,
                        status,
                        lastReceived: new Date().getTime(),
                    });
                } catch (err) {
                    Logger.error('Error loading version data', err);
                    dispatch.systemStatus.loadVersion({ status: 'Network error' });
                }

                await new Promise((resolve) => setTimeout(resolve, delayMs));
            }
        },
    }),
};
